import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { InitValues } from "./UpdateRecoveryServiceForm";
import { ServiceCategoryNewProxy } from "@me-team/host/main/graphql/types";

interface UpdateRecoveryServiceFormEffectsProps {
    pickedCategoryId: number | null;
    initServiceCategory: ServiceCategoryNewProxy | undefined;
    checkIsArchiveCategory: (
        selectedCategory: ServiceCategoryNewProxy | null,
        initialCategory: ServiceCategoryNewProxy | undefined
    ) => void;
}

const UpdateRecoveryServiceFormEffects: React.FC<UpdateRecoveryServiceFormEffectsProps> = ({
    pickedCategoryId,
    initServiceCategory,
    checkIsArchiveCategory,
}) => {
    const { setFieldValue } = useFormikContext<InitValues>();

    useEffect(() => {
        if (pickedCategoryId) {
            setFieldValue("category", pickedCategoryId);
        }
    }, [pickedCategoryId, setFieldValue]);

    useEffect(() => {
        if (initServiceCategory) {
            checkIsArchiveCategory(null, initServiceCategory);
        }
    }, [initServiceCategory, checkIsArchiveCategory]);

    return null;
};

export default UpdateRecoveryServiceFormEffects;
